import UIComponent from "../../common/UIComponent";
import "./index.css";

export default class Bubble extends UIComponent {
  constructor(elementId, interfaces) {
    super();
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.init();
  }

  init() {
    this.bubble = document.createElement("div");
    this.bubble.setAttribute("class", "vhallPlayer-progress-bubble bubble-hide");

    this.insertElement(this.elementId, this.bubble);
  }
}